const BRAZIL_TIMEZONE = 'America/Sao_Paulo'
// Brazil is UTC-3 year-round (no DST since 2019).
const BRAZIL_UTC_OFFSET_HOURS = 3

export function toReal(value: number, decimal = false): string {
  let numberValue = Number(value || 0)

  if (decimal && typeof value !== 'number') {
    numberValue = numberValue / 100
  }

  return numberValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}

export function realToFloat(value: string): number {
  return Number(value.replace(/\D/g, '')) / 100
}

export function toDDMMYYYY(date: string | Date) {
  return new Date(date).toISOString().slice(0, 10)
}

export function convertLocaleDateToStringDay(date: Date): string {
  return date.toLocaleDateString('en-CA', { timeZone: BRAZIL_TIMEZONE })
}

export function convertToTimeZoneDatetime(
  dateString: string,
  type: 'start' | 'end',
  timezoneOffsetHours: number = BRAZIL_UTC_OFFSET_HOURS,
): Date {
  const offsetHours = Math.abs(timezoneOffsetHours)
  const offsetSign = timezoneOffsetHours > 0 ? '-' : '+'
  const timeOfDay = type === 'start' ? 'T00:00:00.000' : 'T23:59:59.999'

  const isoDateTimeWithOffset = `${dateString}${timeOfDay}${offsetSign}${offsetHours
    .toString()
    .padStart(2, '0')}:00`

  return new Date(isoDateTimeWithOffset)
}

export function parseYYYYMMDDtoDDMMYYYY(value: string) {
  if (!value) return ''
  const first10Chars = value.slice(0, 10)
  const parts = first10Chars.split('-')
  const [year, month, day] = parts
  return `${day}/${month}/${year}`
}

export function toLocaleDate(date: string | Date): string {
  if (!date) return ''
  const theDate = new Date(date).toISOString()

  if (theDate.includes('T00:00:00.000Z')) {
    return new Date(theDate)
      .toLocaleDateString('pt-br', { timeZone: 'UTC' })
      .replace(',', '')
  }

  return new Date(theDate).toLocaleString('pt-br').replace(',', '')
}

export function setCredits(valueString = '3000') {
  // if (typeof valueString === 'number') valueString = valueString.toString()
  const removeExtraFromString = valueString.replace(/\D+/g, '')
  const number = Number.parseInt(removeExtraFromString, 10) || 0

  const numberInCent = number / 100
  const numberArray = numberInCent.toFixed(2).split('.')
  numberArray[0] = numberArray[0]?.split(/(?=(?:...)*$)/).join('.') || ''
  const toCent = numberArray.join(',')
  return toCent
}

export function maskCardNumber(v: string) {
  return v
    .replace(/\D/g, '')
    .replace(/^(\d{4})(\d)/g, '$1 $2')
    .replace(/^(\d{4}) (\d{4})(\d)/, '$1 $2 $3')
    .replace(/^(\d{4}) (\d{4}) (\d{4})(\d{4,7})(.*)/, '$1 $2 $3 $4')
}

export function maskCardExpiry(v: string) {
  return (
    v
      // .replace(/\D\//g, '')
      // keep only digits and slash
      .replace(/[^0-9/]/g, '')
      .replace(/^(\d{2})(\/\/\/?\/?)/g, '$1/')
      .replace(/^(\d{2})(\d)/g, '$1/$2')
      .replace(/^(\d{2})\/(\d{2})(.*)/, '$1/$2')
  )
}

export function maskCardCvc(v: string) {
  return v
    .replace(/\D/g, '')
    .replace(/^(\d{4})(\d)/g, '$1')
    .replace(/^(\d{4})(.*)/, '$1')
}

export function maskCEP(v: string) {
  return v
    .replace(/\D/g, '')
    .replace(/^(\d{5})(\d)/g, '$1-$2')
    .replace(/^(\d{5})-(\d{3})(.*)/, '$1-$2')
}

export function maskPhone(v: string): string {
  v = v.replace(/\D/g, '') // Remove tudo o que não é dígito
  v = v.replace(/(.{11})(.*)$/, '$1') // Coloca hífen entre o quarto e o quinto dígitos
  v = v.replace(/^(\d{2})(\d)/g, '($1) $2') // Coloca parênteses em volta dos dois primeiros dígitos
  v = v.replace(/(\d)(\d{4})$/, '$1-$2') // Coloca hífen entre o quarto e o quinto dígitos
  return v
}

export function CNPJMask(v: string) {
  return v
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(
      /^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})(.*)/,
      '$1.$2.$3/$4-$5',
    )
}

export function CPFMask(v: string) {
  return v
    .replace(/\D/g, '') // Remove tudo o que não é dígito
    .replace(/^(\d{3})(\d)/g, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})\/(\d{2})(\d)/, '$1.$2.$3-$4')
}

export function CNPJCPFMask(value: string) {
  if (!value) return ''
  const cleanValue = value.replace(/\D/g, '')
  return cleanValue.length <= 11 ? CPFMask(value) : CNPJMask(value)
}

export function formatDate(date: string | number | Date = new Date()) {
  return new Date(date)
    .toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
    .replace(',', '')
}

export function RGMask(v: string) {
  return v
    .replace(/\D/g, '')
    .replace(/^(\d{1})(\d)/, '$1.$2')
    .replace(/^(\d{1})\.(\d{3})(\d)/, '$1.$2.$3')
}

export function processoJudicialMask(v: string) {
  if (!v) return ''

  return v
    .replace(/\D/g, '')
    .replace(/^(\d{7})(\d)/, '$1-$2')
    .replace(/^(\d{7})-(\d{2})(\d)/, '$1-$2.$3')
    .replace(/^(\d{7})-(\d{2})\.(\d{4})(\d)/, '$1-$2.$3.$4')
    .replace(/^(\d{7})-(\d{2})\.(\d{4})\.(\d{1})(\d)/, '$1-$2.$3.$4.$5')
    .replace(
      /^(\d{7})-(\d{2})\.(\d{4})\.(\d{1})\.(\d{2})(\d)/,
      '$1-$2.$3.$4.$5.$6',
    )
    .replace(
      /^(\d{7})-(\d{2})\.(\d{4})\.(\d{1})\.(\d{2})\.(\d{4})$/,
      '$1-$2.$3.$4.$5.$6',
    )
}
